import Box from "@mui/material/Box";
import type React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { zinc } from "@/ui/tokens";
import { ContextField, ContextText } from "./ContextBlock";

/**
 * One Status tile: an icon, a small uppercase caption, the value, and an optional footnote such as "changed 14:05".
 * Every tile renders through this so the grid reads as one list whatever data it shows; the grid draws the dividers
 * between rows.
 */
export default function ContextTile({
  icon,
  label,
  value,
  footnote,
  span = 1,
}: {
  icon?: React.ReactNode;
  label: string;
  value: React.ReactNode;
  footnote?: React.ReactNode;
  /** Grid columns the tile spans; 2 for wide values like tags. */
  span?: 1 | 2;
}) {
  return (
    <Box
      data-sb={TestIds.dispatch.contextTile}
      sx={{ gridColumn: span === 2 ? "span 2" : undefined, minWidth: 0, borderBottom: `1px solid ${zinc[800]}` }}
    >
      <ContextField icon={icon} label={label}>
        <ContextText variant="value">{value}</ContextText>
        {footnote != null && <ContextText variant="subtext">{footnote}</ContextText>}
      </ContextField>
    </Box>
  );
}
